import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { APP_VERSION } from './content/copy';
import type { EditorRuntimePorts } from './ports/runtime';
import './styles/fonts.css';
import './styles/app.css';

export function mountEditorShell(container: HTMLElement, runtime: EditorRuntimePorts) {
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <App runtime={runtime} />
    </StrictMode>,
  );
  return () => root.unmount();
}

const container = document.getElementById('root');
if (!container) throw new Error('No se encontró el contenedor del editor.');

async function resolveRuntime(): Promise<EditorRuntimePorts> {
  if (import.meta.env.DEV && window.__DG_EDITOR_RUNTIME__) return window.__DG_EDITOR_RUNTIME__;
  if (import.meta.env.DEV && import.meta.env.VITE_SHELL_HARNESS === 'true') {
    const { createHarnessRuntime } = await import('./testing/fakeRuntime');
    return createHarnessRuntime();
  }
  const { createIntegratedRuntime } = await import('./runtime/createIntegratedRuntime');
  return createIntegratedRuntime();
}

void resolveRuntime()
  .then((runtime) => {
    document.documentElement.dataset.runtime = runtime.runtimeKind;
    if (import.meta.env.VITE_DG_E2E_DIAGNOSTICS && runtime.runtimeKind === 'integrated' && runtime.editor.getDiagnosticSnapshot) {
      window.__DG_EDITOR_DIAGNOSTICS__ = { snapshot: runtime.editor.getDiagnosticSnapshot };
      window.__DG_PWA_DIAGNOSTICS__ = { snapshot: runtime.pwa.getSnapshot };
    }
    mountEditorShell(container, runtime);
  })
  .catch((error: unknown) => {
    const detail = error instanceof Error ? error.message : 'Error desconocido';
    container.innerHTML = `<main class="integration-gate"><strong>No se pudo iniciar DG embalajes ${APP_VERSION}</strong><p>${detail.replace(/[<>&"]/gu, '')}</p><button type="button" onclick="location.reload()">Reintentar</button></main>`;
  });
